export default __webpack_public_path__ + "static/media/img_app_ssp.5d9d6d17.jpg";